import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { push } from 'connected-react-router';
import { showConfirmationDialog } from '@actions/confirmation-actions';
import { getConfirmableDeleteAndNavigateAction } from '@actions/data-detail-actions';
import { Icon } from '@mui';
import IconMenu from '@shared/icon-menu';
import IconMenuItem from '@shared/icon-menu-item';
import { getDashboardBackURL } from '@utils/navigation-utils';
import { canEditGroups } from '@utils/permission-utils';
import GanttChartIcon from '@icons/gantt-chart-icon';

const TopBarActionGroupMenu = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { data } = useSelector(state => state.dataDetail);
  const { groupType, id } = useParams();

  const goToGanttChart = () => {
    dispatch(push(
      {
        pathname: `/group/gantt/${groupType}/${id}`,
        state: {
          source: `/group/${groupType}/${id}`
        }
      }
    ));
  };

  const deleteGroup = () => {
    const source = getDashboardBackURL(location, 'group');
    dispatch(showConfirmationDialog(
      'Delete group?',
      `Are you sure you want to delete group "${data.name}"?`,
      getConfirmableDeleteAndNavigateAction('group', 'group', id, source)
    ));
  };

  if (id) {
    return (
      <IconMenu
        icon={<Icon>more_vert</Icon>}
        iconButtonStyles={{}}
        MenuProps={{
          anchorOrigin: { horizontal: 'center', vertical: 'bottom' },
          transformOrigin: { horizontal: 'center', vertical: 'top' }
        }}
        tooltip="more actions"
      >
        <IconMenuItem icon={<GanttChartIcon />} onClick={goToGanttChart}>
          View gantt chart
        </IconMenuItem>
        {canEditGroups(groupType) &&
          <IconMenuItem icon={<Icon>delete</Icon>} onClick={deleteGroup}>
            Delete group
          </IconMenuItem>
        }
      </IconMenu>
    );
  }
  return null;
};

export default TopBarActionGroupMenu;
